/* eslint-disable no-bitwise */

const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : { r: 0, g: 0, b: 0 };
};

const rgbToHex = (rgb: { r: number, g: number, b: number }) => {
  const hex = ((1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).slice(1);
  return `#${hex}`;
};

export const mixColors = (color1: string, color2: string, weight = 0.5) => {
  const rgb1 = hexToRgb(color1);
  const rgb2 = hexToRgb(color2);

  const mixedRgb = {
    r: Math.round(rgb1.r * (1 - weight) + rgb2.r * weight),
    g: Math.round(rgb1.g * (1 - weight) + rgb2.g * weight),
    b: Math.round(rgb1.b * (1 - weight) + rgb2.b * weight),
  };

  return rgbToHex(mixedRgb);
};

export const getFadedColor = (color: string, intensity?: number) => mixColors(
  color,
  '#FFFFFF',
  intensity ?? 0.6,
);
